import React, { useContext } from 'react';
import { Context } from '../../../store/store';
import { StyledShowHamburgerMenuButton } from './show-hamburger-menu-button.styles';

const ShowHamburgerMenuButton = () => {
  const [state, dispatch] = useContext(Context);
  return (
    <StyledShowHamburgerMenuButton
      onClick={() => dispatch({ type: 'TOGGLE_MAIN_MENU_SIDEBAR' })}
      isMainMenuSidebarOpened={state.isMainMenuSidebarOpened}
    >
      <svg
        width="21"
        height="15"
        viewBox="0 0 21 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="18.5" width="2" height="2" rx="1" fill="#7C7C7C" />
        <rect x="18.5" y="6.40039" width="2" height="2" rx="1" fill="#7C7C7C" />
        <rect x="18.5" y="13" width="2" height="2" rx="1" fill="#7C7C7C" />
        <rect y="0.200195" width="16" height="1.5" rx="0.75" fill="#7C7C7C" />
        <rect y="6.7002" width="16" height="1.5" rx="0.75" fill="#7C7C7C" />
        <rect y="13.2002" width="16" height="1.5" rx="0.75" fill="#7C7C7C" />
      </svg>
    </StyledShowHamburgerMenuButton>
  );
};

export default ShowHamburgerMenuButton;
